export const Disclaimer = () => {
  return (
    <p className="text-fg-secondary text-xs pt-8 mt-6 mb-8 border-t border-t-solid border-border-default text-pretty">
      The authors of this content, or members, affiliates, or stakeholders of
      Token Terminal may be participating or are invested in protocols or tokens
      mentioned herein. The foregoing statement acts as a disclosure of
      potential conflicts of interest and is not a recommendation to purchase or
      invest in any token or participate in any protocol. Token Terminal does
      not recommend any particular course of action in relation to any token or
      protocol. The content herein is meant purely for educational and
      informational purposes only, and should not be relied upon as financial,
      investment, legal, tax or any other professional or other advice. None of
      the content and information herein is presented to induce or to attempt to
      induce any reader or other person to buy, sell or hold any token or
      participate in any protocol or enter into, or offer to enter into, any
      agreement for or with a view to buying or selling any token or
      participating in any protocol. Statements made herein (including
      statements of opinion, if any) are wholly generic and not tailored to take
      into account the personal needs and unique circumstances of any reader or
      any other person. Readers are strongly urged to exercise caution and have
      regard to their own personal needs and circumstances before making any
      decision to buy or sell any token or participate in any protocol.
      Observations and views expressed herein may be changed by Token Terminal
      at any time without notice. Token Terminal accepts no liability whatsoever
      for any losses or liabilities arising from the use of or reliance on any
      of this content.
    </p>
  )
}
